export default __webpack_public_path__ + "static/media/gamepad.3c3a12df.svg";